import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";
import api from "../config/api";
import { toast } from "react-toastify";

export const AppointmentContext = createContext();

export const AppointmentProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [ratingLoading, setRatingLoading] = useState(false);
  const [appointmentList, setAppointmentList] = useState({ docs: [], totalDocs: 0, totalPages: 1 });

  const getAppointmentList = async (request) => {
    setLoading(true);
    try {
      const response = await api.appointment.getAppointmentList(request);
      if (response?.success) {
        setAppointmentList(response?.data);
      } else {
        setAppointmentList({ docs: [], totalDocs: 0, totalPages: 1 });
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      setAppointmentList({ docs: [], totalDocs: 0, totalPages: 1 });
    } finally {
      setLoading(false);
    }
  };

  const appointmentRating = async (request) => {
    setRatingLoading(true);
    try {
      const response = await api.appointment.appointmentRating(request);
      if (response?.success) {
        toast.success(response?.message);
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setRatingLoading(false);
    }
  };

  const cancelAppointmentForuser = async (request) => {
    setLoading(true);
    try {
      const response = await api.appointment.cancelAppointment(request);
      if (response?.success) {
        toast.success(response?.message);
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const contextValue = {
    loading,
    ratingLoading,
    appointmentList,
    getAppointmentList,
    appointmentRating,
    cancelAppointmentForuser,
  };
  return (
    <AppointmentContext.Provider value={contextValue}>
      {children}
    </AppointmentContext.Provider>
  );
};

AppointmentProvider.propTypes = {
  children: PropTypes.node,
};

export const useAppointment = () => useContext(AppointmentContext);
